import LocationIcon from '@/../public/icons/LocationIcon.png';
import { ExperienceMode } from '@/generated/graphql';
import styled from '@emotion/styled';
import { Avatar, Popover, useMediaQuery } from '@mui/material';
import { useSearchParams } from 'next/navigation';
import { useRef } from 'react';
import { useExploreQuery } from '../hooks/use-explore-query';
import { useLocationFilterModalAtom } from '../hooks/use-location-filter-modal';
import { LocationStyledButton } from './big-filter-button';
import { LocationFilterModal } from './location-filter-modal';
const StyledAvatar = styled(Avatar)`
  border-radius: 0;
  & > img {
    object-fit: contain;
  }
`;

const LocationFilterButton = () => {
  const searchParams = useSearchParams();
  const mode = searchParams?.get('mode');
  const locality = searchParams?.get('locality');
  const { refetch } = useExploreQuery();
  const buttonRef = useRef(null);
  const { locationFilterModal, setLocationFilterModal } = useLocationFilterModalAtom();

  const onClick = () => {
    setLocationFilterModal(!locationFilterModal);
  };
  const onClose = async () => {
    setLocationFilterModal(false);
    await refetch();
  };

  const startIcon = (
    <StyledAvatar
      src={LocationIcon.src}
      style={{ borderRadius: 0, objectFit: 'contain', height: 20, width: 20 }}
    ></StyledAvatar>
  );
  const isMobile = useMediaQuery('(max-width: 960px');

  if (mode === ExperienceMode.InPerson) {
    return (
      <>
        <LocationStyledButton
          className={locality ? 'active' : 'active'}
          onClick={onClick}
          startIcon={startIcon}
          ref={buttonRef}
        >
          {'Showing:'}&nbsp;
          <span style={{ color: '#1AA16B' }}>{locality ? locality : 'all locations'}</span>
        </LocationStyledButton>
        <Popover
          open={locationFilterModal || false}
          onClose={onClose}
          anchorEl={buttonRef.current}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          PaperProps={
            isMobile
              ? { style: { width: '92%', maxWidth: 1200, borderRadius: 42 } }
              : {
                  style: {
                    width: '100%',
                    maxWidth: 1200,
                    borderRadius: 42,
                  },
                }
          }
        >
          <LocationFilterModal />
        </Popover>
      </>
    );
  }
  return null;
};

export default LocationFilterButton;
